import React from 'react';
import ExchageLatamMileIcon from '../../../common/icons/exchageLatamMileIcon';
import { benefitProgramRpGoUrl } from '../../../../config/paths';

export const exchangeLatamMilesGroup = [
  {
    route: benefitProgramRpGoUrl,
    icon: <ExchageLatamMileIcon size="30px" />,
    title: 'Canje millas Latam',
    id: 'benefitProgramRpGoSection',
    isRedirect: true,
  },
];
